export const sentences = [
  "Little Red Riding Hood decided to wear orange today.",
  "She found it strange that people use their cellphones to actually talk to one another.",
  "I would be delighted if the sea were full of cucumber juice.",
  "I may struggle with geography, but I'm sure I'm somewhere around here.",
  "I never knew what hardship looked like until it started raining bowling balls.",
  "She did not cheat on the test, for it was not the right thing to do.",
  "The secret ingredient to his wonderful life was crime.",
  "He had concluded that pigs must be able to fly in Hog Heaven.",
  "Cats are good pets, for they are clean and are not noisy.",
  "Pink horses galloped across the sea.",
  "You realize you're not alone as you sit in your bedroom massaging your calves after a long day of playing tug-of-war with Grandpa Joe in the hospital.",
  "He was willing to find the depths of the rabbit hole in order to be with her.",
  "It was a slippery slope and he was willing to slide all the way to the deepest depths.",
  "She wanted to be rescued, but only if it was Tuesday and raining.",
  "Poison ivy grew through the fence they said was impenetrable.",
  "They improved dramatically once the lead singer left.",
  "It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
  "If I don't like something, I'll stay away from it.",
  "She is never happy until she finds something to be unhappy about; then, she is overjoyed.",
];
